// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 13rem), 1fr));
  gap: 1.25rem 1rem;
  margin-top: 1rem;
}

.font-specimen {
  display: grid;
  gap: 0.5rem;
  margin: 0;
  min-width: 0;
}

/* Schwarzes Display wie auf der Uhr, unabhängig vom Seitenthema */
.font-display {
  display: grid;
  place-items: center;
  height: 6.5rem;
  overflow: hidden;
  background: #050808;
  border: 1px solid var(--border-primary);
  color: #f2f5f4;
  white-space: nowrap;
  line-height: 1;
}

.font-display span {
  display: inline-block;
}

.font-display-timefonts {
  font-size: 3.4rem;
}

.font-display-datafonts {
  font-size: 1.9rem;
}

.font-specimen figcaption {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
}

.font-name {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FontsPage/FontsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uEAAuE;EACvE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".font-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(min(100%, 13rem), 1fr));\r\n  gap: 1.25rem 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.font-specimen {\r\n  display: grid;\r\n  gap: 0.5rem;\r\n  margin: 0;\r\n  min-width: 0;\r\n}\r\n\r\n/* Schwarzes Display wie auf der Uhr, unabhängig vom Seitenthema */\r\n.font-display {\r\n  display: grid;\r\n  place-items: center;\r\n  height: 6.5rem;\r\n  overflow: hidden;\r\n  background: #050808;\r\n  border: 1px solid var(--border-primary);\r\n  color: #f2f5f4;\r\n  white-space: nowrap;\r\n  line-height: 1;\r\n}\r\n\r\n.font-display span {\r\n  display: inline-block;\r\n}\r\n\r\n.font-display-timefonts {\r\n  font-size: 3.4rem;\r\n}\r\n\r\n.font-display-datafonts {\r\n  font-size: 1.9rem;\r\n}\r\n\r\n.font-specimen figcaption {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: baseline;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.font-name {\r\n  font-family: var(--font-display);\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
